import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Params } from '@angular/router';
import { apis } from '../config/api';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SchoolService {
  http = inject(HttpClient);

  url = apis.schools;

  getSchool(schoolId: string): Observable<any> {
    return this.http.get(`${this.url}/${schoolId}`);
  }

  addSchool(body: Params): Observable<any> {
    const schoolId = parseInt(body['schoolId']);
    return this.http.post(`${this.url}/${schoolId}`, body);
  }

  updateSchool(schoolId: string, params: Params): Observable<any> {
    return this.http.put(`${this.url}/${schoolId}`, params);
  }

  deleteSchoolById(id: number): Observable<any> {
    return this.http.delete(`${this.url}/${id}`);
  }

  getSchoolStats(id: number): Observable<any> {
    return this.http.get(`${this.url}/${id}/stats`);
  }

  getDashboard(schoolId: string, from: string, to: string): Observable<any> {
    return this.http.get(`${this.url}/${schoolId}/dashboard`, {
      params: { from, to },
    });
  }

  getInstructorDashboard(schoolId: string): Observable<any> {
    return this.http.get(`${this.url}/${schoolId}/instructor-dashboard`);
  }

  getActiveStudents(
    schoolId: string,
    from: string,
    to: string,
  ): Observable<any> {
    return this.http.get(`${this.url}/${schoolId}/active-students`, {
      params: { from, to },
    });
  }
}
